<script setup lang="ts">
import { NO_OP } from "vue-composable";
import MAppointmentDiary from "./MAppointmentDiary.vue";
import { AppointmentDiary } from "./types";
import { NOOP } from "@vue/shared";
import { onMounted, ref } from "vue";

const diary: AppointmentDiary = {
  scheduleType: "diary",
  id: "01964407-76f1-737f-a737-f44aed3550e5",
  startDateTime: "2025-04-23 08:00:00",
  endDateTime: "2025-04-23 12:00:00",
  summary: {
    site: {
      id: "01964407-76b2-736e-909a-348485077683",
      name: "Andover Site",
    },
    room: {
      id: "01964407-76be-71fa-bcff-785f29d28e25",
      name: "Consulting Room 3",
    },
    service: {
      id: "01964407-76b4-71aa-8e55-94033e7e43a5",
      name: "GP Surgery",
    },
    status: {
      value: "active",
      label: "Active",
      isActive: true,
      isCancelled: false,
    },
    startDateTime: "2025-04-23 08:00:00",
    endDateTime: "2025-04-23 12:00:00",
    defaultDeliveryMode: {
      value: "face-to-face",
      label: "Face-to-face",
      isFaceToFace: true,
      isHomeVisit: false,
      isPhone: false,
      isVideo: false,
    },
    usualAppointmentDuration: 10,
    assignees: [
      {
        id: "1332aa9c-28d6-11eb-adc1-0242ac120002",
        displayName: "Dr Lara Lincoln",
      },
    ],
    booked: {
      count: 1,
      duration: "10 mins",
    },
    available: {
      count: 0,
      duration: "3 hrs 50 mins",
    },
    additionalInformation: [],
    defaultAppointmentType: {
      id: "01964407-76c8-7362-8a6e-001caa938d14",
      appointmentService: {
        id: "01964407-76b4-71aa-8e55-94033e7e43a5",
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery",
        patientFacingName: null,
        appointmentTypes: [],
      },
      status: {
        value: "active",
        label: "Active",
        isActive: true,
        isArchived: false,
      },
      name: "GP Surgery Default",
      patientFacingName: "Appointment",
      patientFacingOrInternalName: "Appointment",
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      defaultUsualAppointmentDuration: 10,
      defaultNHSNationalSlotTypeCategory: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      internalBookingOpensDaysBeforeContainerStartDate: null,
      internalBookingOpensAtTime: null,
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      gpConnectBookingOpensDaysBeforeContainerStartDate: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
      availableProcedures: [],
    },
    nhsNationalSlotTypeCategoryDefault: {
      value: "30101",
      label: "General Consultation Acute",
      isActive: true,
      isCareRelatedEncounter: true,
    },
    internalBookingOpensDateTime: null,
    patientFacingServicesAvailability: null,
    patientFacingServicesBookingOpensDateTime: null,
    canBeCancelled: false,
    supportsTimedAppointments: true,
    supportsUntimedAppointments: true,
    canBookUntimedAppointments: true,
    isAtCapacity: false,
    hasHighPriorityUntimedAppointments: false,
    diaryTimeline: [
      {
        appointmentTypeId: "01964407-76c8-7362-8a6e-001caa938d14",
        name: "GP Surgery Default",
        startDateTime: "2025-04-23 08:00:00",
        endDateTime: "2025-04-23 12:00:00",
      },
    ],
  },
  entries: [
    {
      isLocalAppointment: true,
      id: "01964408-1c0c-737f-ad7c-e837b2b82639",
      versionId: "2d0b56414374e3e727bdd33abd7e705e",
      overlapsWithOtherAppointments: false,
      patient: {
        id: "01964407-34e3-7399-b661-e87bc6f2a4b1",
        name: "Mr David Gilli",
        firstNames: "Mr David",
        familyName: "Gilli",
        officialDisplayName: "Mr David Gilli",
        nameParts: {
          prefix: "Mr",
          givenName: "David",
          middleNames: "Stuart",
          familyName: "Gilli",
          suffix: null,
        },
        preferredName: null,
        nhsNumber: "9730326827",
        dateOfBirth: "1991-04-17",
        homePhoneNumber: null,
        mobilePhoneNumber: null,
        homeAddress: "10 DURANTS ROAD, ENFIELD, MIDDX, EN3 7AW, GBR",
        emailAddress: null,
        deceased: false,
        risks: [],
      },
      type: {
        value: "timed",
        label: "Timed",
        isTimed: true,
        isUntimed: false,
      },
      diaryEntryType: {
        value: "appointment",
        label: "Appointment",
        isAppointment: true,
        isSlot: false,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      isHighPriority: false,
      isHiddenFromPatientFacingServices: false,
      serviceName: "GP Surgery",
      intendedOrContainerStartDateTime: "2025-04-23 08:00:00",
      intendedOrContainerEndDateTime: "2025-04-23 08:10:00",
      startDateTime: "2025-04-23 08:00:00",
      endDateTime: "2025-04-23 08:10:00",
      duration: 10,
      queueStartDateTime: null,
      queueEndDateTime: null,
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      assignees: "Dr Lara Lincoln",
      location: "Andover Site, Consulting Room 3",
      reasonForAppointment: "Change dressing on wound.",
      additionalInformation: null,
      patientSuppliedInformationForClinician: null,
      compiledReasonForAppointment: "Change dressing on wound.",
      displayStatus: {
        value: "booked",
        label: "Booked",
        isArrived: false,
        isCalledIn: false,
        isBooked: true,
        isDidNotAttend: false,
        isStarted: false,
        isSeen: false,
        isRescheduled: false,
        isCancelled: false,
      },
      createdDateTime: "2025-04-17 14:55:04",
      deliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      appointmentStatus: {
        value: "pending",
        label: "Pending",
        isPending: true,
        isStarted: false,
        isSeen: false,
        isRescheduled: false,
        isCancelled: false,
        isDidNotAttend: false,
      },
      arrivalStatus: null,
      arrivedDateTime: null,
      virtualMeetingRoomId: null,
      encounterId: null,
      encounterIsDraft: null,
      isPending: true,
      formattedTimesAndDuration: "08:00 - 08:10 (10 mins)",
      formattedDateTimeRange: "Wed 23 Apr 2025, 08:00 - 08:10",
      cancelledDateTime: null,
      rescheduledDateTime: null,
      cancellationReason: null,
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      queueId: null,
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 08:10:00",
      endDateTime: "2025-04-23 08:20:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 08:20:00",
      endDateTime: "2025-04-23 08:30:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 08:30:00",
      endDateTime: "2025-04-23 08:40:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 08:40:00",
      endDateTime: "2025-04-23 08:50:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 08:50:00",
      endDateTime: "2025-04-23 09:00:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 09:00:00",
      endDateTime: "2025-04-23 09:10:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 09:10:00",
      endDateTime: "2025-04-23 09:20:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 09:20:00",
      endDateTime: "2025-04-23 09:30:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 09:30:00",
      endDateTime: "2025-04-23 09:40:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 09:40:00",
      endDateTime: "2025-04-23 09:50:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 09:50:00",
      endDateTime: "2025-04-23 10:00:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 10:00:00",
      endDateTime: "2025-04-23 10:10:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 10:10:00",
      endDateTime: "2025-04-23 10:20:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 10:20:00",
      endDateTime: "2025-04-23 10:30:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 10:30:00",
      endDateTime: "2025-04-23 10:40:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 10:40:00",
      endDateTime: "2025-04-23 10:50:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 10:50:00",
      endDateTime: "2025-04-23 11:00:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 11:00:00",
      endDateTime: "2025-04-23 11:10:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 11:10:00",
      endDateTime: "2025-04-23 11:20:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 11:20:00",
      endDateTime: "2025-04-23 11:30:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 11:30:00",
      endDateTime: "2025-04-23 11:40:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 11:40:00",
      endDateTime: "2025-04-23 11:50:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
    {
      isLocalOrganisationSlot: true,
      diaryEntryType: {
        value: "slot",
        label: "Slot",
        isAppointment: false,
        isSlot: true,
        isSlotReservation: false,
        isUnavailabilityPeriod: false,
        isSqueezeInSlot: false,
        isRotaActivityAssignment: false,
        isStaffBreakAssignment: false,
      },
      diaryId: "01964407-76f1-737f-a737-f44aed3550e5",
      bookingRuleSetId: null,
      defaultDeliveryMode: {
        value: "face-to-face",
        label: "Face-to-face",
        isFaceToFace: true,
        isHomeVisit: false,
        isPhone: false,
        isVideo: false,
      },
      nhsNationalSlotTypeCategoryDefault: {
        value: "30101",
        label: "General Consultation Acute",
        isActive: true,
        isCareRelatedEncounter: true,
      },
      patientFacingServicesAvailability: {
        value: "not-available",
        label: "Not available",
        isAvailable: false,
        isNotAvailable: true,
      },
      gpConnectAvailability: {
        value: "not-available",
        label: "Not available",
        isNotAvailable: true,
        isNoRestrictions: false,
        isRestricted: false,
      },
      startDateTime: "2025-04-23 11:50:00",
      endDateTime: "2025-04-23 12:00:00",
      diaryStartDateTime: "2025-04-23 08:00:00",
      diaryEndDateTime: "2025-04-23 12:00:00",
      duration: 10,
      appointmentType: {
        id: "01964407-76c8-7362-8a6e-001caa938d14",
        appointmentService: {
          id: "01964407-76b4-71aa-8e55-94033e7e43a5",
          status: {
            value: "active",
            label: "Active",
            isActive: true,
            isArchived: false,
          },
          name: "GP Surgery",
          patientFacingName: null,
          appointmentTypes: [],
        },
        status: {
          value: "active",
          label: "Active",
          isActive: true,
          isArchived: false,
        },
        name: "GP Surgery Default",
        patientFacingName: "Appointment",
        patientFacingOrInternalName: "Appointment",
        defaultDeliveryMode: {
          value: "face-to-face",
          label: "Face-to-face",
          isFaceToFace: true,
          isHomeVisit: false,
          isPhone: false,
          isVideo: false,
        },
        defaultUsualAppointmentDuration: 10,
        defaultNHSNationalSlotTypeCategory: {
          value: "30101",
          label: "General Consultation Acute",
          isActive: true,
          isCareRelatedEncounter: true,
        },
        internalBookingOpensDaysBeforeContainerStartDate: null,
        internalBookingOpensAtTime: null,
        patientFacingServicesAvailability: {
          value: "not-available",
          label: "Not available",
          isAvailable: false,
          isNotAvailable: true,
        },
        patientFacingServicesBookingOpensDaysBeforeContainerStartDate: null,
        gpConnectAvailability: {
          value: "not-available",
          label: "Not available",
          isNotAvailable: true,
          isNoRestrictions: false,
          isRestricted: false,
        },
        gpConnectBookingOpensDaysBeforeContainerStartDate: null,
        authorisedGPConnectOrganisationTypes: [],
        authorisedGPConnectOrganisations: [],
        availableProcedures: [],
      },
      usualAppointmentDuration: 10,
      internalBookingOpensDateTime: null,
      patientFacingServicesBookingOpensDateTime: null,
      gpConnectBookingOpensDateTime: null,
      siteName: "Andover Site",
      serviceName: "GP Surgery",
      assignees: [],
      assigneeNames: null,
      authorisedGPConnectOrganisationTypes: [],
      authorisedGPConnectOrganisations: [],
    },
  ],
  untimedAppointments: [],
};

const container = ref<HTMLDivElement | null>(null);

onMounted(() => {
  if (container.value) {
    container.value.scrollBy({
      top: 200,
    });
  }
});
</script>

<template>
  <div ref="container" style="width: 500px; height: 500px; overflow: auto">
    <m-appointment-diary
      :title="diary.summary.service.name"
      :diary="diary"
      :show-diary-controls="true"
      heading="GP Surgery"
      @click="NO_OP"
      @cancel-diary="NOOP"
    />
  </div>
</template>
